import { RaterAnswers } from '@/modules/common/rater/models/APP/RaterAnswers'

export default class DentalRaterAnswers extends RaterAnswers {
  // private _forWhom!: string
  hasRelationship: string
  hasHealthInsurance: string

  constructor(data: any = {}) {
    super(data)

    this.forWhom = data.forWhom
    this.forWhomPeople = data.forWhomPeople ?? 1
    this.hasRelationship = data.hasRelationship ?? 'yes'
    this.hasHealthInsurance = data.hasHealthInsurance
  }

}
